import React, { useContext, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import {
  Button,
  Dropdown,
  DropdownButton,
  Image,
  Toast,
} from "react-bootstrap";
import { get, find, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { useFormikContext } from "formik";
import { InnerLayoutButtons } from "../";
import {
  createPlanStore,
  setManagePlanFlow,
  setManagePlanToastInfo,
  getPlanDetailsAction,
  getReviewAndPlanDetailsAction,
  setPageLevelPlanStatus,
} from "../../contexts";
import tenantConfig from "../../mocks/tenantOne.json";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import {
  ALL_MANAGE_PLAN_ROUTES,
  MANAGE_PLAN_ROUTES,
  ROUTES,
  managePlanFormNames,
  apiErrors,
  getPathWithParam,
  FLOW_TYPES,
  populateManagePlanForm,
} from "../../utils";
import { listBasicPlanDetails, setPlanStatus } from "../../services";
import Cancel from "../../styles/cancel.png";
import RouteLeavingGuard from "../RouteLeavingGuard";
import CompensationTableRow from "../CompensationTable/CompensationTableRow";

const ManagePlanLayout = ({
  children,
  buttons = [],
  pageFlow,
  layoutHeader,
  customBreadCrumbs,
  history,
  blockNavigation,
  useBlockNavigationAlways = false,
  onFormRefresh = () => {},
  setDropdownDetails,
  handleDropdownButton,
  clickedOn,
  dirtyFlagCheck = false,
  eligibilityIndex,
}) => {
  const [showError, setShowError] = useState(false);
  const { state, dispatch } = useContext(createPlanStore);
  const { planId, flow } = useRouterParams();
  const apiData = get(state, "api.reviewAndPlanDetail", {});

  const planName = get(
    state,
    `${managePlanFormNames.BASIC_DETAILS_MANAGE_PLAN}.planName`,
    get(apiData, "planName")
  );
  const { showToast, toastMessage } = state;
  const formikContext = useFormikContext();
  const {
    values,
    isSubmitting,
    dirty,
    resetForm,
    setSubmitting,
    errors,
  } = useFormikContext() || {
    dirty: false,
  };

  const apiError = get(state, "api.error", {});
  const menuDetails = find(ALL_MANAGE_PLAN_ROUTES, (item) => {
    if (get(state, "selectedMenu", "").indexOf(get(item, "path")) !== -1) {
      return true;
    }
    return false;
  });

  const setPlanStatusAc = () => {
    const reviewAndPlanDetail = get(state, "api.reviewAndPlanDetail", {});
    const tenantReview =
      !isEmpty(reviewAndPlanDetail.review) &&
      Object.fromEntries(
        Object.entries(reviewAndPlanDetail.review).filter(([key]) =>
          tenantConfig.planSubMenu.filter((_) => _ !== "review").includes(key)
        )
      );

    const planStatus = reviewAndPlanDetail.planStatus;
    const status =
      !isEmpty(tenantReview) && Object.values(tenantReview).includes(false)
        ? 0
        : planStatus == 3
        ? 3
        : 1;
    if (planStatus !== 5) {
      if (
        planStatus !== null &&
        (formikContext?.isSubmitting || status !== planStatus)
      ) {
        setPlanStatus(parseInt(planId, 10), status).then(async (response) => {
          dispatch(
            setPageLevelPlanStatus({
              planStatus: status,
            })
          );
        });
      }
    }
  };

  useDeepEffect(() => {
    if (isEmpty(apiData) && planId) {
      dispatch(getReviewAndPlanDetailsAction(planId, dispatch, state));
      dispatch(setManagePlanFlow({ flow, planId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planId]);

  useDeepEffect(() => {
    if (state?.api?.reviewAndPlanDetail) setPlanStatusAc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.api?.reviewAndPlanDetail, isSubmitting]);

  useDeepEffect(
    () => {
      if (!isEmpty(apiError)) {
        setShowError(true);
      }
    },
    [apiError],
    true
  );

  const breadCrumOptions = [
    {
      label: "Home",
      link: ROUTES.HOME,
    },
    {
      label: "Manage Plan",
      link: ROUTES.PLAN,
    },
  ];

  if (planName) {
    breadCrumOptions.push({
      label: planName,
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.BASIC_DETAILS,
        pathParam: [FLOW_TYPES.EDIT, planId],
      }),
    });
  }

  const breadCrumbsFromMenuDetails = get(menuDetails, "breadCrumbs", []);
  if (!isEmpty(customBreadCrumbs)) {
    breadCrumOptions.push(...customBreadCrumbs);
  } else if (!isEmpty(breadCrumbsFromMenuDetails)) {
    breadCrumOptions.push(
      ...breadCrumbsFromMenuDetails.map((item) => ({
        ...item,
        link: getPathWithParam({
          path: item.link,
          pathParam: [FLOW_TYPES.EDIT, planId],
        }),
      }))
    );
  }

  const onRefresh = () => {
    if (resetForm) {
      onFormRefresh();
      resetForm();
      setSubmitting(false);
    }
  };
  const handleDropdown = (button, choice) => {
    if (button == "delete" && choice == "immediate") {
      handleDropdownButton({ button: "delete", choice: "immediate" });
    } else if (button == "delete" && choice == "amendment") {
      handleDropdownButton({ button: "delete", choice: "amendment" });
    } else if (button == "save" && choice == "immediate") {
      handleDropdownButton({ button: "save", choice: "immediate" });
    } else if (button == "save" && choice == "amendment") {
      handleDropdownButton({ button: "save", choice: "amendment" });
    }
  };

  const errorStatus = get(apiError, "response.status", 500);
  const errorData = apiErrors[errorStatus];

  return (
    <div className="d-flex flex-column manage-company layout-height">
      <div className="d-flex flex-column layout-header">
        <div className="d-flex align-items-center">
          <div>
            <h5>{layoutHeader || get(menuDetails, "contentHeader", "")}</h5>
          </div>
          <div
            className="ml-auto"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <InnerLayoutButtons
              menu="plan"
              subMenu={get(menuDetails, "id", "")}
              buttonsList={buttons}
              flow={pageFlow}
            />
            {layoutHeader === "Eligibility Rule" &&
              (pageFlow === "save" || pageFlow === "add") && (
                <DropdownButton
                  title="Save"
                  style={{ width: "90px" }}
                  align="end"
                  id="dropdown-menu-align-end"
                  className={"request-dropdown"}
                >
                  <Dropdown.Item style={{ paddingLeft: "0px" }}>
                    <p
                      className="mb-0 fw-400 ft-12"
                      onClick={() => handleDropdown("save", "immediate")}
                    >
                      As Rule
                    </p>
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    disabled={
                      values["eligibilityRuleFor"] == "1" &&
                      eligibilityIndex == 0
                    }
                    style={{ paddingLeft: "0px" }}
                  >
                    <p
                      className="mb-0 fw-400 ft-12"
                      onClick={() => handleDropdown("save", "amendment")}
                    >
                      As Amendment
                    </p>
                  </Dropdown.Item>
                </DropdownButton>
              )}
          </div>
          {showError && (
            <div
              className={`error-banner justify-content-between d-flex align-items-center ${
                (showError && "enable") || ""
              }`}
            >
              <div>
                <Image src={Cancel} width="30px" />
              </div>
              <div>
                <div className="error-heading">{"errorData.heading"}</div>
                <div className="error-reason">{errorData.reason}</div>
              </div>
              <div>
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  color="#000"
                  style={{ fontSize: "14px" }}
                  onClick={() => setShowError(false)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="layout-content h-100 overflow-auto">{children}</div>
      <Toast
        onClose={() =>
          dispatch(
            setManagePlanToastInfo({
              showToast: false,
              toastMessage: "",
            })
          )
        }
        show={showToast}
        style={{
          position: "fixed",
          top: "10rem",
          right: "2rem",
          zIndex: "100",
        }}
        delay={3000}
        autohide
      >
        <Toast.Body className="success-toast-align">
          <div className="mr-2">
            {showToast ? (
              <FontAwesomeIcon icon={faCheckCircle} color="#3BB54A" size="lg" />
            ) : (
              ""
            )}
          </div>
          <div>{toastMessage}</div>
          <div className="ml-2">
            {showToast ? (
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000000"
                size="md"
                onClick={() =>
                  dispatch(
                    setManagePlanToastInfo({
                      showToast: false,
                      toastMessage: "",
                    })
                  )
                }
              />
            ) : (
              ""
            )}
          </div>
        </Toast.Body>
      </Toast>
      <RouteLeavingGuard
        when={
          ((!isSubmitting && (dirty || dirtyFlagCheck)) ||
            (isSubmitting && !isEmpty(errors))) ??
          false
          //   && !blockNavigation) ||
          // (useBlockNavigationAlways && !blockNavigation)
        }
        navigate={(path) => history.push(path)}
        onRefresh={onRefresh}
      />
    </div>
  );
};

export default withRouter(ManagePlanLayout);
